import Helper from "./Helper";

class ScrollToSection {
  constructor(config = {}) {
    const {} = config;
    this.section = Array.prototype.slice.call(document.querySelectorAll('.ns-section'));
    this.sidenavi = Array.prototype.slice.call(document.querySelectorAll('.side-menu__item'));
    this.navi2 = Array.prototype.slice.call(document.querySelectorAll('.menu__item--level-1'));

    this.sideMenuLinks = Array.prototype.slice.call(document.querySelectorAll('.side-menu__link'));
    this.subnaviLinks = Array.prototype.slice.call(document.querySelectorAll('.menu__link--level-1'));

    this.content = document.querySelector('.content');
    this.body = document.querySelector('body');

    this.fromTop = 0;
    this.actualURL = window.location.pathname;
    if(this.section.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.bindLinks();
    this.isNavActive(this.sidenavi, this.fromTop, true);
    this.isNavActive(this.navi2, this.fromTop, false);
    if (window.location.hash) {
      const hash = window.location.hash;
      this.scrollTo(this.content);
      setTimeout(() => {
        window.location.hash = hash;
        this.scrollTo(this.section[window.location.hash.substring(1) - 1]);
      }, 200);
    }

    window.addEventListener("scroll", (e) =>{
      this.fromTop = window.scrollY;
      this.isNavActive(this.sidenavi, this.fromTop, true);
      this.isNavActive(this.navi2, this.fromTop, false);
    });
  }

  bindLinks(){
    this.sideMenuLinks.forEach(l => {
      l.addEventListener('click', e => {
        if(window.location.pathname === this.actualURL) {
          e.preventDefault();
          let id = parseInt(l.getAttribute("href").split('#')[1]) - 1;
          let clickedSection = this.section[id];
          this.scrollTo(clickedSection);
        }
      });
    });

    this.subnaviLinks.forEach(l => {
      l.addEventListener('click', e => {
        if(window.location.origin + window.location.pathname === l.href.split('#')[0]) {
          e.preventDefault();
          let id = parseInt(l.getAttribute("href").split('#')[1]) - 1;
          let clickedSection = this.section[id];
          this.scrollTo(clickedSection);
        }
      });
    });
  }

  scrollTo(element) {
    let paddingTop = parseInt(getComputedStyle(element).paddingTop);
    let scrollTop = paddingTop ? element.offsetTop + paddingTop : element.offsetTop;
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: scrollTop
    });
  }

  isNavActive(navItems, fromTop, scrollOnFront) {
    navItems.forEach((link)=>{
        let aTag = link.querySelector('a');
        let hash = aTag.hash;
        let url = aTag.href.split('#')[0];
        let section = hash ? document.getElementById((hash.split('#')[1])) : null;
        if(section && (url === window.location.origin + window.location.pathname || scrollOnFront)) {
          if (section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop) {
            link.classList.add("active");
          } else {
            link.classList.remove("active");
          }
        }
    });
  }
}

export default ScrollToSection;
